import React, { CSSProperties, PropsWithChildren } from "react";
import styled from "styled-components";
import {
  OverlayProps as SharedOverlayProps,
  overlayStyles,
} from "@shared/common/Overlays/Overlay";

export interface OverlayProps extends SharedOverlayProps {
  wrapStyle?: CSSProperties;
  className?: string;
  hideWithOpacity?: boolean;
  showContent?: boolean; // Props to prevent changing of parent component that causes children to unmount
}

const Overlay: React.FunctionComponent<PropsWithChildren<OverlayProps>> = ({
  isLoading,
  children,
  spinnerMarginTop,
  overlayOpacity,
  hideContentWhileLoading,
  backgroundColor,
  wrap,
  wrapStyle,
  zIndex,
  className,
  overlayContent,
  hideWithOpacity,
  showContent: propsShowContent,
}) => {
  const showContent =
    !hideContentWhileLoading || !isLoading || propsShowContent;
  const spinnerWrapperProps = {
    $spinnerMarginTop: spinnerMarginTop,
    $overlayOpacity: overlayOpacity,
    $backgroundColor: backgroundColor,
    $zIndex: zIndex,
    className: className,
  };

  const contentWithLoading = (
    <>
      {isLoading && (
        <OverlayWrapper {...spinnerWrapperProps}>
          {overlayContent}
        </OverlayWrapper>
      )}
      {hideContentWhileLoading ? (
        <ContentWrapper
          $hide={!showContent}
          $hideWithOpacity={hideWithOpacity}
          style={wrapStyle}
        >
          {children}
        </ContentWrapper>
      ) : (
        children
      )}
    </>
  );

  return wrap ? (
    <div
      style={{
        height: "100%",
        width: "100%",
        position: "relative",
        ...(wrapStyle || {}),
      }}
    >
      {contentWithLoading}
    </div>
  ) : (
    contentWithLoading
  );
};

export default Overlay;

export const OverlayWrapper = styled.div<{
  $backgroundColor?: string;
  $zIndex?: number;
  $spinnerMarginTop?: number;
  $overlayOpacity?: number;
  $rounded?: boolean;
}>`
  ${overlayStyles};
`;
const ContentWrapper = styled.div<{
  $hide: boolean;
  $hideWithOpacity?: boolean;
}>`
  ${(p) => {
    if (p.$hide) {
      return p.$hideWithOpacity ? "opacity: 0;" : "display: none;";
    }
  }};
`;
